import { render, staticRenderFns } from "./ImgUploader.vue?vue&type=template&id=5c06229e&"
import script from "./ImgUploader.vue?vue&type=script&lang=js&"
export * from "./ImgUploader.vue?vue&type=script&lang=js&"
import style0 from "./ImgUploader.vue?vue&type=style&index=0&id=5c06229e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports